import request from "../auth/request"

// 获取顶级单位
export const getAllSassOrg = params => request({
    url: '/v1.0/company/getAllSassOrg',
    method: 'GET',
    params
})

// 获取列表数据
export const getCountProjectList = params => request({
    url: '/v1.0/Project/getCountProjectList',
    method: 'GET',
    params
})

//获取签约落地记录
export const getProjectContact = params => request({
    url: '/v1.0/Project/getProjectContact',
    method: 'GET',
    params
})

// 获取开庭公告详情
export const getCourtAnnoCheckDeatail = params => request({
    url: '/v1.0/company/getCourtAnnoCheckDeatail',
    method: 'GET',
    params
})

// 获取失信详情
export const getShixinCheckDeatail = params => request({
    url: '/v1.0/company/getShixinCheckDeatail',
    method: 'GET',
    params
})

// 获取被执行人详情
export const getZhixingCheckDetail = params => request({
    url: '/v1.0/company/getZhixingCheckDetail',
    method: 'GET',
    params
})

// 获取裁判文书详情
export const getJudgmentDocCheckDetail = params => request({
    url: '/v1.0/company/getJudgmentDocCheckDetail',
    method: 'GET',
    params
})

// 获取司法拍卖详情
export const getJudicialSaleCheckDetail = params => request({
    url: '/v1.0/company/getJudicialSaleCheckDetail',
    method: 'GET',
    params
})

// 获取股权出质详情
export const getEquityPledgedCheckDetail = params => request({
    url: '/v1.0/company/getEquityPledgedCheckDetail',
    method: 'GET',
    params
})

// 获取股权冻结详情
export const getEquityFreezeCheckDetail = params => request({
    url: '/v1.0/company/getEquityFreezeCheckDetail',
    method: 'GET',
    params
})

// 获取行政处罚详情
export const getAdminPenaltyCheckDetail = params => request({
    url: '/v1.0/company/getAdminPenaltyCheckDetail',
    method: 'GET',
    params
})

// 获取土地抵押详情
export const getLandMortgageCheckDetail = params => request({
    url: '/v1.0/company/getLandMortgageCheckDetail',
    method: 'GET',
    params
})

// 获取环保处罚详情
export const getEnvPunishmentCheckDetail = params => request({
    url: '/v1.0/company/getEnvPunishmentCheckDetail',
    method: 'GET',
    params
})

// 获取税收违法详情
export const getTaxIllegalCheckDetail = params => request({
    url: '/v1.0/company/getTaxIllegalCheckDetail',
    method: 'GET',
    params
})



// 获取领奖详情
export const BusinessUserProjectGetMoney = params => request({
    url: '/v1.0/Project/BusinessUserProjectGetMoney',
    method: 'GET',
    params
})